<template>
  <div>
        <span v-for="(parcours, index) in parcoursList" :key="index" class="parcours-list">
            <span>{{ parcours }}</span>
            <span v-if="index < last">&nbsp;&#183;&nbsp;</span>
        </span>
  </div>
</template>

<script>
export default {
  name: 'parcours',
  props: ['parcoursList'],
  computed: {
    last() {
      return Object.keys(this.parcoursList).length - 1;
    }
  }
}
</script>

<style scoped>
span.parcours-list {
  display: inline-block;
}
</style>